exports.STYLE_EVALUATION = {
  exceptional: {
    label: 'exceptional',
    score: 10,
    style: [9, 10],
  },
  great: {
    label: 'great',
    score: 5,
    style: [4.5, 8.9],
  },
  solid: {
    label: 'solid',
    score: 1,
    style: [1.5, 4.4],
  },
};
